// ============================================================
// TEXT ANIMATIONS
// ============================================================

export function initTextAnimations() {
    const textElements = document.querySelectorAll(
        '.animated-text, .section-heading h2, .section-heading h3, .page-heading h1, .page-heading h2'
    );

    if (textElements.length === 0) return;

    const wordBasedEffects = ['fade-words', 'words-slide-up', 'words-rotate-in', 'words-slide-from-right'];

    textElements.forEach(element => {
        let safeHtml = element.innerHTML.replace(/<br\s*\/?>/gi, ' ###BR### ');

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = safeHtml;
        const text = tempDiv.textContent.trim();

        const effectType = element.dataset.effect || element.getAttribute('data-anim') || 'letters-stagger-right';
        let speed = parseFloat(element.dataset.speed) || 0.05;

        const isWordEffect = wordBasedEffects.includes(effectType);
        if (isWordEffect && !element.dataset.speed) speed = 0.15;

        element.setAttribute('data-effect', effectType);
        element.classList.add('animated-text');
        element.innerHTML = '';

        let globalIndex = 0;

        text.split(/\s+/).forEach((wordText, index, array) => {
            if (wordText === '###BR###') {
                element.appendChild(document.createElement('br'));
                return;
            }

            const wordWrapper = document.createElement('span');
            wordWrapper.classList.add('word');

            if (isWordEffect) {
                wordWrapper.innerText = wordText;
                wordWrapper.style.transitionDelay = `${globalIndex * speed}s`;
                globalIndex++;
            } else {
                wordText.split('').forEach(char => {
                    const span = document.createElement('span');
                    span.innerText = char;
                    span.style.transitionDelay = `${globalIndex * speed}s`;
                    wordWrapper.appendChild(span);
                    globalIndex++;
                });
            }

            element.appendChild(wordWrapper);

            if (index < array.length - 1) {
                element.appendChild(document.createTextNode(' '));
            }
        });
    });

    const observerOptions = {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                obs.unobserve(entry.target);
            }
        });
    }, observerOptions);

    textElements.forEach(el => observer.observe(el));
}
